import React from "react";

import { AdminDialog } from "#app/components/admin/admin-dialog";
import { createDialogEmitter } from "#app/lib/dialog-emitter";

type AdminDialogActions = {
  openDialog: () => void;
  closeDialog: () => void;
};

// The console is opened from the account menu and from the `/admin` deep
// link, which fires BEFORE the workspace layout (and so the mount) exists;
// the emitter's store holds that open until the mount reads it.
const adminDialog = createDialogEmitter("admin");

/** Open the admin console. Module-level so a route can call it without a
 *  hook. */
export function openAdminDialog(): void {
  adminDialog.open();
}

/** Stable open/close callbacks. Works inside portalled overlays. */
export function useAdminDialogActions(): AdminDialogActions {
  return React.useMemo<AdminDialogActions>(
    () => ({ openDialog: adminDialog.open, closeDialog: adminDialog.close }),
    [],
  );
}

/** Mounts the dialog once, in the workspace layout beside the other
 *  emitter-driven overlays. */
export function AdminDialogMount() {
  const { open } = adminDialog.useDialogState();
  return <AdminDialog open={open} onClose={adminDialog.close} />;
}
